import React, { Component, PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import config from '../../../config';
import styles from '../../MainPage/elements/MainPageCarBrandList.scss';
import _ from 'lodash';
import Media from 'react-responsive';
import * as actions from '../../../redux/categoriesActions';



export class GarageCarBrandList extends Component {
  constructor(props, context){
    super(props, context);
    this.props.actions.getBrands();
  }
  render() {
    const brandList = _.sortBy(this.props.brandList, [(brand) => brand.brandName.toLowerCase()]);
    const garageLink = config.routes.garage;
    const brands = _(brandList).map((brand, i, list) => {
      const brandCapitalLetter = list[i-1] && list[i-1].brandName[0] === list[i].brandName[0]
        ? '' : brand.brandName[0];

      return (
        <div
          data-capital={brandCapitalLetter || undefined}
          className={styles.brand}>
          <Link
            to={`${garageLink}/${brand.brandId}`}
            key={`brand{i}`}
          >
            {brand.brandName}
          </Link>


        </div>
      );
    }).value();
    return (
      <div className={ styles.carBrandListContainer }>
      <ul className={styles.carBrandList}>
        {brands}
        </ul>
       </div>
    );
  }
}

GarageCarBrandList.propTypes = {
  brandList: React.PropTypes.array,
  actions: PropTypes.object.isRequired
};


function mapStateToProps(state) {
  return {
    ...state.catalogReducer,
    ...state.categoriesReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GarageCarBrandList);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/GarageCarBrandList.jsx
 **/